import * as React from "react";
import { IFormElementProps } from "../Element/OptionElement";


export default function withPlaceHolder(Component:React.FC<IFormElementProps>,placeholder:string){
    return (props:IFormElementProps)=>{
        return <Component {...props} placeholder={placeholder}/>
    }
}